module.exports = __webpack_public_path__ + "static/business_finance_management-173ed3cb8688b2bada22fc4d92a4a3f0.webp";